<mat-form-field color="accent" class="full-width reset-margin--bottom">
    <mat-label for="country">{{ label }}</mat-label>
    <input
        matInput
        type="text"
        id="country"
        i18n-placeholder="@@select-placeholder-country"
        placeholder="Select country"
        i18n-aria-label="@@select-placeholder-country"
        aria-label="Select country"
        [formControl]="countryCode"
        [matAutocomplete]="options" />

    <mat-autocomplete autoActiveFirstOption #options="matAutocomplete">
        <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option.region"
            (onSelectionChange)="countrySelect(option)">
            {{ option.region }}
        </mat-option>
    </mat-autocomplete>

    <button
        *ngIf="countryCode.value"
        matSuffix
        mat-icon-button
        class="riege-button riege-button--icon"
        type="button"
        aria-label="Clear"
        i18n-aria-label="@@button-label-clear"
        (click)="clearInput()">
        <mat-icon class="riege-icon">close</mat-icon>
    </button>
</mat-form-field>
